/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/TriPeaksTemplate/TriPeaksWindowsTemplate',[
        'lodash',
        'pixi',
        'util/eventhandler',
        'Arkadium/GameEngine/Core/EngineManagers',
        'CardUI/SupplyView',
        'CardUI/PileView',
        'CardUI/KeyboardNavigator',
        'SolitaireShared/CardLogic/Supply',
        'SolitaireShared/TriPeaksLogic/TriPeaksAuthority',
        'SolitaireShared/TriPeaksTemplate/TriPeaksInputInterpreter',
        'SolitaireShared/TriPeaksTemplate/TriPeaksCardAnimator',
        'Arkadium/GameEngine/Maths/Vector2',
        'util/SettingsManager', 
        'absolute'],
    function (_, PIXI, EventHandler, EngineManagers, SupplyView, PileView, KeyboardNavigator,
              Supply, TriPeaksAuthority, TriPeaksInputInterpreter, TriPeaksCardAnimator, Vector2,
                SettingsManager, Absolute) {
        "use strict";

        var TriPeaksWindowsTemplate = function () {
            this.initTriPeaksWindowsTemplate();
        };

        TriPeaksWindowsTemplate.prototype.initTriPeaksWindowsTemplate = function () {
            this._authorityReference = null;
            this._supplyViewReference = null;
            this._curAutoSolveView = null;
            this._curAutoSolveViewOnUpdated = new EventHandler();
        };

        TriPeaksWindowsTemplate.prototype.CreateAuthority = function (challenge) {
            var authority = challenge != null
                ? challenge.ConstructAuthority()
                : new TriPeaksAuthority();

            authority.Setup();
            authority.CardSupply.DeckSeed = null;

            this._authorityReference = authority;
            return authority;
        };

        TriPeaksWindowsTemplate.prototype.Cleanup = function () {

        };

        TriPeaksWindowsTemplate.prototype.CreateInputInterpreter = function (authority) {
            return new TriPeaksInputInterpreter(authority);
        };

        TriPeaksWindowsTemplate.prototype.CreateCardAnimator = function (supplyView) {
            return new TriPeaksCardAnimator(supplyView);
        };

        TriPeaksWindowsTemplate.prototype.TryAutoSolve = function (supplyView) {
        };

        TriPeaksWindowsTemplate.prototype.StopAutoSolving = function () {
        };

        TriPeaksWindowsTemplate.prototype.DoLayoutPiles = function (renderManager, supplyView) {
            var isLeft = SettingsManager.getSetting('tripeaks', 'layoutDirection') === '1';
            var width = EngineManagers.Display.Width;
            var height = EngineManagers.Display.Height;
            var minWidth = 320;

            // reset all keyboard handlers
            _.forEach(supplyView.CardSupply.GetPileList(), function (p) {
                if (p != null) {
                    var pileView = supplyView.GetPileView(p);
                    if (pileView != null)
                        pileView.Keyboard.ResetKeypressHandlers();
                }
            }, this);

            var pile;
            var cardScale = 0.92;
            var pileScale = 1.0;
            var rowScale = 0.76;

            if (width / (height) < 1.5) {
                cardScale *= 0.85;
                rowScale *= 0.855;
            }

            //pileScale = 1.0;
            var row = [0.20 - 0.5, 0.33 - 0.5, 0.46 - 0.5, 0.59 - 0.5];
            var botRow = 0.83 - 0.5;

            if (this._authorityReference.IsChallenge) {
                row = [0.16 - 0.5, 0.29 - 0.5, 0.44 - 0.5, 0.55 - 0.5];
                botRow = 0.785 - 0.5;
            }

            var col =
                [
                    (0.0 / 18.0 - 0.5) * rowScale,
                    (1.0 / 18.0 - 0.5) * rowScale,
                    (2.0 / 18.0 - 0.5) * rowScale,
                    (3.0 / 18.0 - 0.5) * rowScale,
                    (4.0 / 18.0 - 0.5) * rowScale,
                    (5.0 / 18.0 - 0.5) * rowScale,
                    (6.0 / 18.0 - 0.5) * rowScale,
                    (7.0 / 18.0 - 0.5) * rowScale,
                    (8.0 / 18.0 - 0.5) * rowScale,
                    (9.0 / 18.0 - 0.5) * rowScale,
                    (10.0 / 18.0 - 0.5) * rowScale,
                    (11.0 / 18.0 - 0.5) * rowScale,
                    (12.0 / 18.0 - 0.5) * rowScale,
                    (13.0 / 18.0 - 0.5) * rowScale,
                    (14.0 / 18.0 - 0.5) * rowScale,
                    (15.0 / 18.0 - 0.5) * rowScale,
                    (16.0 / 18.0 - 0.5) * rowScale,
                    (17.0 / 18.0 - 0.5) * rowScale,
                    (18.0 / 18.0 - 0.5) * rowScale
                ];

            var colIndices = [3, 9, 15, 2, 4, 8, 10, 14, 16, 1, 3, 5, 7, 9, 11, 13, 15, 17, 0, 2, 4, 6, 8, 10, 12, 14, 16, 18];
            var rowIndices = [0, 0, 0, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3];

            var rightFocus = [18, 19, 9, 20, 10, 3, 21, 11, 4, 0, 22, 12, 23, 13, 5, 24, 14, 6, 1, 25, 15, 26, 16, 7, 27, 17, 8, 2];
            var leftFocus = [27, 26, 17, 25, 16, 8, 24, 15, 7, 2, 23, 14, 22, 13, 6, 21, 12, 5, 1, 20, 11, 19, 10, 4, 18, 9, 3, 0];

            var midFocus = [22, 23, 21, 24, 20, 15, 19, 26, 18, 27, 13, 12, 14, 11, 15, 10, 16, 9, 17, 5, 6, 4, 7, 3, 8, 1, 0, 2];


            pile = supplyView.GetPileView("Stock");
            pile.CardFacing = PileView.Facing.FaceDown;
            pile.PileMode = PileView.Layout.FanRight;
            pile.FanLimit = 999;
            pile.ScaleX = pileScale;
            pile.ScaleY = pileScale;
            // HERE
            // pile.LogicalScreenPos = new Vector2(((6.0 / 14.0 - 0.5) - 1.0 / 56.0) * rowScale, botRow + 0.02);//new Vector2(col[7], botRow);
            var column = isLeft ? ((6.0 / 14.0 - 0.5) - 1.0 / 56.0) : ((8.0 / 14.0 - 0.5) + 1.0 / 56.0);

            if (Absolute.Platform.isMobile())
                column = isLeft ? ((6.0 / 14.0 - 0.5) - 1.0 / 12.0) : ((8.0 / 14.0 - 0.5) + 1.0 / 12.0);

            pile.LogicalScreenPos = new Vector2(column * rowScale, botRow + 0.02);//new Vector2(col[7], botRow);
            pile.InteractionMode = PileView.Interaction.Click;
            pile.DisplayType = PileView.Display.Stock;
            pile.KeyboardMode = PileView.KeyboardModes.TopCardAndEmpty;
            var direction = isLeft ? 1 : -1;
            pile.DefaultPileSpacing = new Vector2(direction * 6 / 300.0 * cardScale, 0);
            pile.FullyCompressOnDeal = false;
            pile.HeightLimit = 1;

            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Left, supplyView.GetPileView("Stock"));
            for (var i = 0; i < midFocus.length; i++) {
                pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Up, supplyView.GetPileView("Tableau" + midFocus[i]));
            }

            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Activate, function (pv, dir) {
                if (pv instanceof PileView) // it should be!
                {
                    if (pv.Pile.Empty) {
                        //#if !GAMESTATETOOL
                        // trigger the empty pile draw
                        var keyboardUI = pv.SupplyView.GetKeyboardUI("dealnextdeck");
                        if (keyboardUI != null)
                            keyboardUI.Keyboard.HandleKeypress(KeyboardNavigator.KeyPress.Activate);
                        //#endif
                    }
                }
                return false;
            });

            supplyView.DefaultKeyboardFocus = supplyView.GetPileView("Stock");

            pile = supplyView.GetPileView("Waste");
            pile.CardFacing = PileView.Facing.FaceUp;
            pile.PileMode = PileView.Layout.Pile;
            pile.ScaleX = pileScale;
            pile.ScaleY = pileScale;
            column = isLeft ? ((8.0 / 14.0 - 0.5) + 1.0 / 56.0) : ((6.0 / 14.0 - 0.5) - 1.0 / 56.0);

            if (Absolute.Platform.isMobile())
                column = isLeft ? ((8.0 / 14.0 - 0.57)) : ((8.0 / 14.0 - 0.57));

            pile.LogicalScreenPos = new Vector2(column * rowScale, botRow + 0.02); //new Vector2(col[11], botRow);
            pile.InteractionMode = PileView.Interaction.None;

            pile = supplyView.GetPileView("Root");
            pile.LogicalScreenPos.set(supplyView.GetPileView("Waste").LogicalScreenPos.x + 99, supplyView.GetPileView("Waste").LogicalScreenPos.y + 99);
            pile.DefaultPileSpacing = new Vector2(0, 0);
            pile.CardFacing = PileView.Facing.Hidden;
            pile.PileMode = PileView.Layout.Pile;
            pile.InteractionMode = PileView.Interaction.None;

            pile = supplyView.GetPileView("Joker");
            pile.LogicalScreenPos = new Vector2(col[0], botRow);
            pile.CardFacing = PileView.Facing.FaceUp;
            pile.PileMode = PileView.Layout.Pile;
            pile.ScaleX = pileScale;
            pile.ScaleY = pileScale;
            pile.InteractionMode = PileView.Interaction.Click;
            pile.KeyboardMode = PileView.KeyboardModes.TopCard;
            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Right, supplyView.GetPileView("Stock"));
            for (var i = 0; i < rightFocus.length; i++) {
                pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Up, supplyView.GetPileView("Tableau" + rightFocus[i]));
            }
            for (var i = 0; i < 28; i++) {
                pile = supplyView.GetPileView("Tableau" + i);

                pile.CardFacing = PileView.Facing.FaceUp;
                pile.PileMode = PileView.Layout.Pile;
                pile.LogicalScreenPos = new Vector2(col[colIndices[i]], row[rowIndices[i]]);
                pile.InteractionMode = PileView.Interaction.Click;
                pile.DisplayType = PileView.Display.Blank; // No shadows without this line (probably engine bug with texture alpha and/or the depth buffer).
                pile.ScaleX = pileScale;
                pile.ScaleY = pileScale;
                pile.AllowClickWhenEmpty = false;

                pile.KeyboardMode = PileView.KeyboardModes.TopCard;

                for (var k = 0; k < rightFocus.length; k++) {
                    if (rightFocus[k] == i) {
                        for (var j = k + 1; j < rightFocus.length; j++) {
                            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Right, supplyView.GetPileView("Tableau" + rightFocus[j]));
                        }
                        for (var j = 0; j < k; j++) {
                            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Right, supplyView.GetPileView("Tableau" + rightFocus[j]));
                        }
                        break;
                    }
                }
                for (var k = 0; k < leftFocus.length; k++) {
                    if (leftFocus[k] == i) {
                        for (var j = k + 1; j < leftFocus.length; j++) {
                            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Left, supplyView.GetPileView("Tableau" + leftFocus[j]));
                        }
                        for (var j = 0; j < k; j++) {
                            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Left, supplyView.GetPileView("Tableau" + leftFocus[j]));
                        }
                        break;
                    }
                }
                pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Down, supplyView.GetPileView("Stock"));

                pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Tab, supplyView.GetPileView("Stock"));
            }

            for (var i = 0; i < 18; i++) {
                pile = supplyView.GetPileView("FaceDown" + i);

                pile.CardFacing = PileView.Facing.FaceDown;
                pile.PileMode = PileView.Layout.Pile;
                pile.LogicalScreenPos = new Vector2(col[colIndices[i]], row[rowIndices[i]]);
                pile.InteractionMode = PileView.Interaction.None;
                pile.ScaleX = pileScale;
                pile.ScaleY = pileScale;
                pile.AllowClickWhenEmpty = false;
            }

            supplyView.CardScale = cardScale;
        };

        TriPeaksWindowsTemplate.prototype.LoadGameOptions = function (supply) {
        };

        TriPeaksWindowsTemplate.prototype.SaveGameOptions = function (supply) {

        };

        Object.defineProperty(TriPeaksWindowsTemplate.prototype, "EndGameStatStrings",
            {
                get: function () {
                    return ["Boards Played", "Score"];
                }
            });

        TriPeaksWindowsTemplate.prototype.GetEndGameStats = function () {
            return [
                this._authorityReference.CurrentDeal.ToString(),
                "" + this._authorityReference.CardSupply.Score  // TODO check this
            ];
        };

        Object.defineProperty(TriPeaksWindowsTemplate.prototype, "GameName", {
            get: function () {
                return "TriPeaks";
            }
        });

        Object.defineProperty(TriPeaksWindowsTemplate, "SuitsOptionKey", {
            get: function () {
                return "TRIPEAKS_SAVE_FILE";
            }
        });

        return TriPeaksWindowsTemplate;

    });

